import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n';

type HeaderProps = {
  title?: React.ReactNode;
  showBack?: boolean;
  onBack?: () => void;
};

const Header = ({ title, showBack = false, onBack }: HeaderProps) => {
  const navigate = useNavigate();
  const showBackBtn = showBack || !!onBack;
  return (
    <header className="flex h-16 w-full shrink-0 items-center justify-between border-b border-[var(--border)] px-3 sm:h-[88px] sm:px-6" style={{ background: 'rgba(10,10,10,0.55)', backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)' }}>
      {showBackBtn ? (
        <button
          type="button"
          aria-label={t.back}
          className="touch-target group flex h-13 min-w-0 cursor-pointer items-center gap-1.5 rounded-xl px-2.5 font-display text-[clamp(0.85rem,1.3vw,1.15rem)] font-medium uppercase tracking-[0.1em] text-[var(--muted)] transition-all duration-150 hover:text-[var(--cream)] active:scale-[0.96] sm:gap-2.5 sm:px-4"
          onPointerUp={() => onBack ? onBack() : navigate(-1)}
        >
          <svg
            aria-hidden
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="transition-transform duration-150 group-active:-translate-x-0.5"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
          {t.back}
        </button>
      ) : (
        <div className="w-16 sm:w-[180px]" />
      )}

      <div className="min-w-0 flex-1 px-1 text-center">
        {title ? (
          <span className="block truncate font-display text-[clamp(1.1rem,2vw,1.85rem)] font-bold tracking-[0.06em] text-[var(--cream)]">
            {title}
          </span>
        ) : (
          <span className="font-display text-[clamp(1.3rem,4vw,1.7rem)] font-bold uppercase tracking-[0.16em] text-[var(--gold-lt)]">
            RUSH<span className="ml-1 text-[0.6em] font-medium tracking-[0.2em] text-[var(--cream)]">NIGHT</span>
          </span>
        )}
      </div>

      <div className="w-16 sm:w-[180px]" />
    </header>
  );
};

export default Header;